import { Dispatch } from 'redux';
import { connect } from 'react-redux';
import { withRouter, RouteComponentProps } from 'react-router'

import { AppState } from "store";
import WithdrawalComplete from 'components/student/WithdrawalComplete';
import sessionActions from 'actions/sessionActions'

const mapDispatchToProps = (dispatch: Dispatch) => {
  return {
    logout: () => dispatch(sessionActions.deleteSession()),
  };
}

const mapStateToProps = (appState: AppState, ownProps: RouteComponentProps) => {
  return {
    ...ownProps,
  }
}

type connectMappedProps = ReturnType<typeof mapDispatchToProps> & ReturnType<typeof mapStateToProps>
export type mappedProps = connectMappedProps;

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(WithdrawalComplete))
